<template>
  <div class="seckill-highlight-time-component">
    <div v-for="(group, gIndex) in timeArray"
         :key="gIndex"
         class="seckill-highlight-time-group"
    >
      <div v-for="(item, index) in group"
           :key="index"
           class="seckill-highlight-time-item"
      >
        {{ item }}
      </div>
      <div v-if="gIndex !== (timeArray.length - 1)"
           class="seckill-highlight-time-delimiter"
      ></div>
    </div>
  </div>
</template>

<script>
  import { formatTime } from '@/utils';

  export default {
    name: 'SeckillHighlightTime',
    props: {
      time: {
        type: Number,
        required: true,
      },
    },
    computed: {
      timeArray() {
        const { time } = this;
        if (time <= 0) return [];
        const str = formatTime(time, 'HH:ii');
        return str.split(':').map(group => group.split(''));
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .seckill-highlight-time {
    &-component {
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }

    &-group {
      display: flex;
      align-items: center;
    }

    @highlight-time-width: 34px;
    @highlight-time-height: 46px;
    @highlight-time-margin: 8px;
    &-item {
      display: flex;
      width: @highlight-time-width;
      height: @highlight-time-height;
      margin-left: @highlight-time-margin;
      align-items: center;
      justify-content: center;
      font-size: @font-size-large;
      font-weight: @font-weight-bold;
      color: @color-text-base;
      border-radius: @border-radius-normal;
      background: @color-white;
    }


    @highlight-delimiter-size: 8px;
    &-delimiter {
      margin-left: @highlight-time-margin;

      &::before, &::after {
        content: '';
        display: block;
        width: @highlight-delimiter-size;
        height: @highlight-delimiter-size;
        border-radius: 1px;
        background: @color-white;
      }

      &::before {
        margin-bottom: @highlight-delimiter-size;
      }
    }
  }
</style>
